export default __webpack_public_path__ + "static/media/90s_column@3x.bc259bd8.png";